import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

/**
 * Safely converts any axios / API error into a human-readable string.
 * Handles Pydantic 422 arrays (each item has {type, loc, msg, input, ctx}),
 * plain string details, and unknown shapes — never returns an object.
 */
export function apiErr(err, fallback = "Something went wrong") {
  const d = err?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) {
    return d
      .map((e) => {
        if (typeof e === "string") return e;
        const field = Array.isArray(e?.loc) ? e.loc.filter((p) => p !== "body").join(".") : "";
        const msg = e?.msg || "invalid value";
        return field ? `${field}: ${msg}` : msg;
      })
      .join(" · ");
  }
  if (d && typeof d === "object") return d.message || JSON.stringify(d);
  return err?.message || fallback;
}

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("param_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401 && !window.location.pathname.startsWith("/login")) {
      localStorage.removeItem("param_token");
      localStorage.removeItem("param_user");
      window.location.href = "/login";
    }
    return Promise.reject(err);
  },
);
